const doc = [({"da":({"js":({"admin":({"communication":({"index":({"communication":"Kommunikation"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;